import NoDataText from "../../../../components/emptyState/emptyStateText";

function Tel1Summary({ summaryData = [] }) {
  return (
    <>
      <div className="d-flex flex-column">
        {summaryData.length > 0 ? (
          summaryData.map((val, index) => (
            <div key={index} className="mb-3">
              <div className="d-flex mt-1 text-opacity-50 small">
                <div>
                  <i className="fa fa-circle text-warning fs-6px d-block mt-2"></i>
                </div>
                <div className="flex-1 ps-2">
                  <div className="text-theme">{val.listText}</div>
                </div>
              </div>
              <div className="d-flex mt-1 text-inverse text-opacity-50">
                <div className="row ps-3">
                  {val.value.length > 0
                    ? val.value.map((v, i) => (
                        <div key={i} className="col-2">
                          <div>
                            {v.rate}: <span className={v.qty > 0 ? "text-danger" : "text-opacity-50"}>{v.qty}</span>
                          </div>
                        </div>
                      ))
                    : ""}
                </div>
              </div>
            </div>
          ))
        ) : (
          <NoDataText />
        )}
      </div>
    </>
  );
}

export default Tel1Summary;
